import * as React from 'react';

const SvgCurrencySmall = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15'
    height='18'
    viewBox='0 0 15 18'
    fill='none'
  >
    <path
      d='M8.74266 14.062H6.25666V5.526C5.30332 5.67267 4.62866 6.02467 4.23266 6.582C3.85132 7.12467 3.66066 7.814 3.66066 8.65V18H0.866656V8.672C0.866656 6.88267 1.35799 5.54067 2.34066 4.646C3.32332 3.73667 4.62866 3.216 6.25666 3.084V0.839999H8.74266V3.084C10.4 3.216 11.7127 3.73667 12.6807 4.646C13.6633 5.54067 14.1547 6.88267 14.1547 8.672V18H11.3607V8.65C11.3607 7.814 11.1627 7.12467 10.7667 6.582C10.3707 6.02467 9.69599 5.67267 8.74266 5.526V14.062Z'
      fill='#FF0037'
    />
  </svg>
);

export default SvgCurrencySmall;
